module.exports = __webpack_public_path__ + "01_hair_silver.302e3bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/01_hair_silver.png
// module id = EZUB
// module chunks = 0